import { CircleSolidIcon, InfoIcon, StackIcons } from '@dhl-ui/icons'

// Icon combining a yellow circle with an info symbol and no border
export const InfoYellowIcon = () => (
  <StackIcons variant="centered" sx={{ mr: 1 }}>
    <CircleSolidIcon color="secondary" />
    <InfoIcon />
  </StackIcons>
)
